import type { Document, Text, Block, Inline } from "@contentful/rich-text-types";

type ContentNode = Text | Block | Inline;

const hasContent = (node: ContentNode): boolean => {
    if (node.nodeType === "text") {
        return !!(node as Text).value?.trim();
    }

    // If the node has nested content, recursively check it
    if ("content" in node && Array.isArray(node.content)) {
        return node.content.some((childNode) => hasContent(childNode as ContentNode));
    }

    // Other node types without content are considered meaningful
    return true;
};

export const removeEmptyContent = (doc: Document): Document => {
    return {
        ...doc,
        content: doc.content.filter((c) => {
            if (!c.content || c.content.length === 0) {
                return false;
            }

            // Recursively check if there's any meaningful content
            return c.content.some((cc) => hasContent(cc as ContentNode));
        }),
    };
};
